// 分類來自各自的查詢結果，不使用代表操作身分的 type。
export const isSmartCareTag = tag => Number(tag.tag_type) === 2 || tag.customize_care_tag_id != null;
export const customReserveTags = tags => (tags || []).filter(tag => !isSmartCareTag(tag));
// 所有診所均開放；醫師仍需選擇實際診所，不能以「全部」查詢智能標籤。
export const isSmartCareClinic = clinicCode => {
  const code = String(clinicCode || '').trim();
  return Boolean(code) && code !== 'all';
};
export const reserveTagIds = tags => (tags || []).map(tag => tag.tag_id);

export function sameTagSelection(a, b) {
  const left = new Set(a.map(String));
  const right = new Set(b.map(String));
  return left.size === right.size && [...left].every(id => right.has(id));
}

export function reserveTagChanges(custom, smart, original, enabled) {
  const result = {};
  if (!original || !sameTagSelection(custom, reserveTagIds(original.reserve_tag))) result.reserve_tag = [...custom];
  if (enabled && (!original || !sameTagSelection(smart, reserveTagIds(original.smart_care_tag)))) result.smart_care_tag = [...smart];
  return result;
}

export function smartCareDeliveryUnavailable(patient, { ownerType = '1', phoneVisible = false } = {}) {
  if (!patient) return false;
  const phone = String(patient.phone || '').trim();
  if (!phone && phoneVisible && Object.prototype.hasOwnProperty.call(patient, 'phone')) {
    return true;
  }
  // 手機缺漏或遮罩不代表未綁定，僅採用當前發送帳號的明確狀態。
  const key = String(ownerType) === '2' ? 'doctor_oa_status' : 'clinic_oa_status';
  const status = patient[key] === null ? patient.dentco_oa_status : patient[key];
  return ['0', '-1'].includes(String(status));
}

export function normalizeReserveCareSchedules(response, reserveNo) {
  const groups = response && response.data && response.data.data;
  if (!Array.isArray(groups) || groups.some(group =>
    String(group.reserve_no) !== String(reserveNo) || !Array.isArray(group.messages)
  )) throw new Error('約診排程資料不符');
  return groups;
}
